"use strict";
// packages/types/src/hazard.ts
Object.defineProperty(exports, "__esModule", { value: true });
